import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import CallDevicesIndex from 'dashboard/components-next/CallDevices/CallDevicesIndex.vue';
import CallDeviceDashboard from 'dashboard/components-next/CallDevices/CallDeviceDashboard.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/call-devices'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'call_devices_wrapper',
          meta: {
            permissions: ['administrator'],
          },
          redirect: to => ({
            name: 'call_devices_list',
            params: to.params,
          }),
        },
        {
          path: 'list',
          name: 'call_devices_list',
          meta: {
            permissions: ['administrator'],
          },
          component: CallDevicesIndex,
        },
        {
          path: ':deviceId',
          name: 'call_device_dashboard',
          meta: {
            permissions: ['administrator'],
          },
          component: CallDeviceDashboard,
        },
      ],
    },
  ],
};
